// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__yCAx3","footer":"ReportModalFilter_footer__CMKJ7"};